<template>
  <div class="container">
    <el-row class="common-box">
      <div class="common-search">
        <el-form
          ref="formData"
          :model="formData"
          :inline="true"
          label-width="90px"
          class="formInline"
          size="mini"
          :rules="rules"
        >
          <el-form-item label="身份证号" prop="idCard">
            <el-input
              v-model="formData.idCard"
              placeholder="请输入身份证号..."
              :maxlength="18"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="salemansName">
            <el-input
              v-model="formData.salemansName"
              placeholder="请输入姓名..."
              :maxlength="6"
            ></el-input>
          </el-form-item>
          <el-form-item label="促销员ID" prop="empPk">
            <el-input
              v-model="formData.empPk"
              placeholder="请输入促销员ID..."
              :maxlength="12"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否QHR人员" label-width="20" prop="qhrStatus">
            <el-select v-model="formData.qhrStatus" placeholder="请选择">
              <el-option label="全部" value="0"></el-option>
              <el-option label="否" value="5"></el-option>
              <el-option label="是" value="6"></el-option>
              <el-option label="在职" value="1"></el-option>
              <el-option label="离职中" value="2"></el-option>
              <el-option label="取消离职" value="3"></el-option>
              <el-option label="离职" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="search-btn" @click="getData(1)">搜索</el-button>
            <el-button
              class="search-btn"
              @click="exportData"
              style="margin-left: 20px"
              >导出</el-button
            >
            <el-button
              class="search-btn"
              style="margin-left: 20px"
              @click="uploadDialogi = true"
              >新增</el-button
            >
            <el-button
              class="search-btn"
              style="margin-left: 20px"
              @click="insertBatchs"
              >上传数据</el-button
            >
            <!---->
          </el-form-item>

          <!-- <el-form-item>
            <el-button class="search-btn" @click="downloadTmp()">下载模板</el-button>
            
          </el-form-item> -->
          <!-- size="mini" :disabled="auths.indexOf(2) < 0" round @click="uploadDialog=true" 
          size="mini" :disabled="auths.indexOf(2) < 0"  round @click="downloadTmp"
          -->
        </el-form>
      </div>
      <div class="common-box-body">
        <el-table
          :data="tableData"
          size="small"
          v-loading="listLoading"
          element-loading-text="拼命加载中"
          border
          style="width: 100%"
          header-row-class-name="table-header"
        >
          <el-table-column
            type="index"
            label="编号"
            width="50"
            align="center"
          ></el-table-column>
          <!-- <el-table-column prop="idCard" label="身份证" align="center" :formatter = "formatIdCard"></el-table-column>
          <el-table-column prop="salemansName" label="姓名" align="center" :formatter = "formatName"></el-table-column> -->
          <el-table-column
            prop="idCard"
            label="身份证"
            align="center"
            :formatter="formatIdCard"
          ></el-table-column>
          <el-table-column
            prop="salemansName"
            label="姓名"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="empPk"
            label="促销员ID"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="qhrStatusName"
            label="是否是qhr人员"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="reason"
            label="拉黑原因"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="userName"
            label="操作用户"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="拉黑时间"
            align="center"
            :formatter="formatDate"
          ></el-table-column>
          <!-- <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="remove(scope.row.salesmanId)">移除黑名单</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination
          class="pagination table-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="slot, total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
    <!--上传对话框 action="/rest/CrmBlacklist/importBlackList"
                                  :before-upload="handlePreview"
                                  :on-success='handleSuccess'
                                  :on-error='handleError'
                                  :show-file-list="false"
          -->
    <el-dialog
      class="dialog"
      title="上传黑名单数据"
      :visible.sync="uploadDialog"
      width="500px"
      center
    >
      <div class="dialog-body">
        <div style="display: flex">
          <a
            style="color: blue; font-size: 18px; width: 41%"
            @click="downloadTmp()"
            >下载模板</a
          >
          <div>
            <el-upload
              class="upload-demo"
              ref="upload"
              :action="action"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :on-error="handleError"
              :auto-upload="false"
              :limit="1"
              :data="{ operatorId: openid }"
              :on-exceed="exceed"
            >
              <!-- <el-a  slot="trigger"  style="color: blue; margin-left: 130px;">上传附件</el-a>  -->
              <a slot="trigger" @click="$refs.upload.clearFiles()" style="color: blue; font-size: 18px" 
                >上传附件</a
              >
            </el-upload>
            <div slot="tip" class="el-upload__tip" v-if="fileList.length == 0">
              只能上传excel文件
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button class="dialog-btn" size="small" @click="bbb()">确认上传</el-button> -->
        <el-button
          class="dialog-btn"
          size="small"
          type="success"
          @click="submitUpload"
          >确认上传</el-button
        >
      </span>
    </el-dialog>

    <!--新增对话框-->
    <el-dialog
      class="dialog"
      title="新增黑名单数据"
      :visible.sync="uploadDialogi"
      width="600px"
      center
    >
      <div class="dialog-body">
        <div style="display: flex; align-items: center">
          <span style="width: 80px">身份证号:</span
          ><el-input
            v-model="formData.cardId"
            placeholder="请输入身份证号..."
            :maxlength="18"
          ></el-input>
        </div>
        <div style="display: flex; align-items: center; margin-top: 10px">
          <span style="width: 80px">姓名:</span
          ><el-input
            v-model="formData.name0"
            placeholder="请输入姓名..."
            :maxlength="20"
          ></el-input>
        </div>
        <div style="display: flex; align-items: center; margin-top: 10px">
          <span style="width: 80px">拉黑原因:</span
          ><el-input
            type="textarea"
            v-model="formData.reason"
            placeholder="请输入拉黑原因..."
            :maxlength="200"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-btn" size="small" @click="aaa()"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from "../../common/js/util.js";
import moment from "moment";

export default {
  data() {
    return {
      action: `/rest/CrmBlacklist/importBlackList?operatorId=${sessionStorage.getItem(
        "sysUserId"
      )}`,
      openid: sessionStorage.getItem("sysUserId"),
      pageNo: 1,
      pageSize: 10,
      total: null,
      formData: {
        salemansName: null,
        idCard: null,
        empPk: null,
        pageNo: 1,
        qhrStatus: null,
        pageSize: 10,
      },

      tableData: [],
      listLoading: false,
      uploadDialog: false,
      uploadDialogi: false,
      fileList: [],
      rules: {
        idCard: [
          {
            pattern:
              /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
            message: "请输入15位或18位身份证号",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getData();
    this.$refs["formData"].resetFields();
  },
  methods: {
    formatIdCard(row, column, cellValue) {
      if (
        sessionStorage.getItem("user") == "admin1" ||
        sessionStorage.getItem("user") == "tinashi"
      ) {
        return cellValue;
      } else {
        return utils.plusXing(cellValue, 6, 4);
      }
    },
    formatName(row, column, cellValue) {
      let a = cellValue[0];
      if (
        sessionStorage.getItem("user") == "admin1" ||
        sessionStorage.getItem("user") == "tinashi"
      ) {
        return cellValue;
      } else {
        for (let i = 0; i < cellValue.length - 1; i++) {
          a = a + "*";
        }
        return a;
      }
    },
    insertBatchs() {
      this.uploadDialog = true;
    },
    getData(pageNo) {
      if (pageNo) {
        this.formData.pageNo = 1;
      }
      this.listLoading = true;
      this.$http({
        method: "POST",
        url: "/rest/CrmBlacklist/findCBByIdCardAndName",
        params: this.formData,
      })
        .then((res) => {
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch((err) => {
          if (err.response) {
            let errMsg;
            if (err.response.message) {
              errMsg = err.response.message;
            } else {
              errMsg = "查询失败，请稍后重试";
            }
            this.$notify({
              title: "失败",
              message: errMsg,
              type: "error",
            });
          }
          this.listLoading = false;
        });

      this.$http({
        method: "POST",
        url: "/rest/CrmBlacklist/countCrmBlacklist",
        params: this.formData,
      })
        .then((res) => {
          this.total = res.data;
        })
        .catch((err) => {
          let errMsg;
          if (err.response.message) {
            errMsg = err.response.message;
          } else {
            errMsg = "查询失败，请稍后重试";
          }
          this.$notify({
            title: "失败",
            message: errMsg,
            type: "error",
          });
        });
    },
    handleSizeChange(val) {
      this.formData.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.formData.pageNo = val;
      this.getData();
    },
    formatDate(row, column, cellValue) {
      if (cellValue) {
        return moment(cellValue).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    remove(id) {
      this.$http({
        method: "POST",
        url: "/rest/CrmBlacklist/removeCrmBlacklist",
        params: {
          id: id,
        },
      })
        .then((res) => {
          this.getData();
          this.$notify({
            title: "成功",
            message: "移除黑名单成功",
            type: "success",
          });
        })
        .catch((err) => {
          let errMsg;
          if (err.response.message) {
            errMsg = err.response.message;
          } else {
            errMsg = "操作失败，请稍后重试";
          }
          this.$notify({
            title: "失败",
            message: errMsg,
            type: "error",
          });
        });
    },
    downloadTmp() {
      this.$http({
        method: "POST",
        url: "/rest/CrmBlacklist/downloademplate",
      })
        .then((res) => {
          if (
            res &&
            res.data &&
            (res.data.code == 0 || res.data.code == null)
          ) {
            location.href = utils.returnUrlHead() + res.data.message;
          }
        })
        .catch((err) => {
          utils.myNotify(this, "error", err.response, "查询失败，请稍后重试");
        });
    },
    handleSuccess(response, file, fileList) {
      console.log("222", fileList);
      if (response.message == "操作成功") {
        this.getData();
        this.uploadDialog = false;
      }
      this.$alert(response.message, "提示", {
        dangerouslyUseHTMLString: true,
        // callback() {
        //   this.uploadDialog = false;
        // },
      });
    },
    handleError(err, response, file) {
      let msg = "文件上传失败";
      if (!response || !response.message) {
        msg = "请求超时，请稍后再试";
      } else {
        msg = response.message;
        msg = msg.split("。").join("\n");
      }
      this.$alert(msg, "提示", {
        dangerouslyUseHTMLString: true,
        callback: (action) => {
          this.uploadDialog = false;
        },
      });
    },
    exportData() {
      this.listLoading = true;
      this.$http({
        method: "get",
        url: "/rest/CrmBlacklist/export",
        params: {
          idcard: this.formData.idcard,
          name: this.formData.salemansName,
          qhrStatus:this.formData.qhrStatus,
          empPk: this.formData.empPk,
        },
      })
        .then((res) => {
          location.href = utils.returnUrlHead() + res.data.data;
          this.listLoading = false;
        })
        .catch((err) => {
          if (err.response) {
            let errMsg;
            if (err.response.message) {
              errMsg = err.response.message;
            } else {
              errMsg = "导出失败，请稍后重试";
            }
            this.$notify({
              title: "失败",
              message: errMsg,
              type: "error",
            });
          }
          this.listLoading = false;
        });
    },
    //点击确定
    aaa() {
      // this.formatDate.cardId,
      this.$http({
        method: "POST",
        url: "/rest/CrmBlacklist/addBlack",
        data: {
          cardId: this.formData.cardId,
          reason: this.formData.reason,
          name: this.formData.name0,
          operatorId: sessionStorage.getItem("sysUserId"),
        },
      })
        .then((res) => {
          if (
            res &&
            res.data &&
            (res.data.code == 0 || res.data.code == null)
          ) {
            utils.myNotify(this, "success", res.data.message);
            this.uploadDialogi = false;
          }
          if (
            res &&
            res.data &&
            (res.data.code == 1 || res.data.code == null)
          ) {
            utils.myNotify(this, "error", res.data.message);
          }
        })
        .catch((err) => {
          utils.myNotify(this, "error", err.response, "新增失败，请稍后重试");
        });
    },
    // action="/rest/CrmBlacklist/importBlackList"
    //                               :before-upload="handlePreview"
    //                               :on-success='handleSuccess'
    //                               :on-error='handleError'
    //                               :show-file-list="false"
    submitUpload() {
      // operatorId: sessionStorage.getItem('sysUserId')
      console.log(this.openid);
      this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {
      console.log(2);

      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(3);

      console.log(file);
    },
    exceed(files, fileList) {
      // this.$refs.upload.clearFiles();
      utils.myNotify(this, "warning", "只能上传一个文件,请删除后重新上传！");
    },
    handleUpload() {
      console.log(111);
      this.$refs.upload.clearFiles();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-btn {
  margin-left: 75px;
}
</style>




// WEBPACK FOOTER //
// src/views/personnelCenter/blackList.vue